export const previewFileHlsModalName = 'preview-file-hls';
